import { render, staticRenderFns } from "./QuoteComponent.vue?vue&type=template&id=7be0747e&"
import script from "./QuoteComponent.vue?vue&type=script&lang=js&"
export * from "./QuoteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports